import Vue from 'vue';
import installmentCalculator from './installment-calculator/installment-calculator.vue';
import store from '../common/js/vuex/store';
import installmentCalculatorStore from './installment-calculator/installment-calculator-vuex';
if (!store.hasModule(['installmentCalculator'])) {
	store.registerModule('installmentCalculator', installmentCalculatorStore);
}
Vue.component('installment-calculator', installmentCalculator);
